<template>
    <v-container
            pa-0
            fill-height
            fluid
            style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;"
            v-if="!!menuData"
    >
        <v-btn absolute
               color="white"
               class="rounded-lg"
               left
               text
               to="/app-select"
               top
        >Apps
        </v-btn>
        <v-btn absolute
               color="white"
               class="rounded-lg"
               right
               text
               top
               @click="logout()"
        >Logout
        </v-btn>
        <v-row align="center" class="fill-height white--text" justify="center" no-gutters>
            <v-col align-self="center" style="max-width: 1000px;">
                <v-row align="center" class="fill-height" justify="center">
                    <v-col cols="12">
                        <div class="display-3 text-center">{{ menuData.title }}</div>
                        <v-card class="mt-4" color="rgba(255,255,255,0.4)" :height="4"></v-card>
                    </v-col>
                    <v-col v-for="tool in menuData.tools" :key="tool.id" cols="auto">
                        <v-row justify="center" no-gutters>
                            <v-hover>
                                <template v-slot:default="{ hover }">
                                    <v-card
                                            class="pa-3 rounded-lg"
                                            dark
                                            height="130"
                                            style="transition: all 0.15s;"
                                            :color="hover ? tool.hover_color : tool.color"
                                            :to="`/${$route.params.app+tool.to}`"
                                            :width="tool.width"
                                    >
                                        <v-row align="center" class="fill-height" justify="center" no-gutters>
                                            <v-col cols="12">
                                                <v-row justify="center" no-gutters>
                                                    <v-icon class="mb-2" x-large>{{ tool.icon }}</v-icon>
                                                </v-row>
                                                <div class="title text-center" style="line-height: 1.2;">{{ tool.name }}</div>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </template>
                            </v-hover>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    export default {
        name: 'Home',
        data: () => ({
            menuData: null,
            app: null
        }),
        components: {},
        methods: {
            importMenuData() {
                if (this.$route.params.app === 'pwc-tdc-toolkit') {
                    this.menuData = require('@/assets/tdc/menu.json');
                } else if (this.$route.params.app === 'meridian-tdc-toolkit') {
                    this.menuData = require('@/assets/meridian/menu.json');
                } else if (this.$route.params.app === 'fitt-accreditation-training') {
                    this.menuData = require('@/assets/fat/menu.json');
                } else if (this.$route.params.app === 'gulf-health-council-tdc-toolkit') {
                    this.menuData = require('@/assets/ghc/menu.json');
                } else if (this.$route.params.app === 'medihelp-tdc-toolkit') {
                    this.menuData = require('@/assets/medihelp/menu.json');
                } else if (this.$route.params.app === 'maaden-exec-tdc-toolkit') {
                    this.menuData = require('@/assets/maadenexec/menu.json');
                } else if (this.$route.params.app === 'maaden-direc-tdc-toolkit') {
                    this.menuData = require('@/assets/maadendirec/menu.json');
                } else if (this.$route.params.app === 'eskom-tdc-toolkit') {
                    this.menuData = require('@/assets/eskom/menu.json');
                } else if (this.$route.params.app === 'sec-tdc-toolkit') {
                    this.menuData = require('@/assets/sec/menu.json');
                } else if (this.$route.params.app === 'spb-tdc-toolkit') {
                    this.menuData = require('@/assets/spb/menu.json');
                } else if (this.$route.params.app === 'peak-activities') {
                    this.menuData = require('@/assets/peak/menu.json');
                } else if (this.$route.params.app === 'nomac-pdp-workshop') {
                    this.menuData = require('@/assets/nomac/menu.json');
                } else if (this.$route.params.app === 'nomac-n3-tdc-toolkit') {
                    this.menuData = require('@/assets/nomacn3/menu.json');
                } else if (this.$route.params.app === 'nomac-n4-tdc-toolkit') {
                    this.menuData = require('@/assets/nomacn4/menu.json');
                } else if (this.$route.params.app === 'sec-peak') {
                    this.menuData = require('@/assets/secpeak/menu.json');
                } else if (this.$route.params.app === 'qafco-tdc-toolkit') {
                    this.menuData = require('@/assets/qafco/menu.json');
                } else if (this.$route.params.app === 'armscor-tdc-toolkit') {
                    this.menuData = require('@/assets/armscor/menu.json');
                } else if (this.$route.params.app === 'ncs') {
                    this.menuData = require('@/assets/ncs/menu.json');
                } else if (this.$route.params.app === 'general') {
                    this.menuData = require('@/assets/general/fusion.json');
                }
            },
            logout() {
                this.$store.dispatch('setAuthFalse').then(
                        () => {
                            this.$router.replace('/');
                        }
                );
            }
        },
        mounted() {
            this.app = this.$route.params.app;
            this.importMenuData();
        }
    }
</script>
